function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Unmute microphone");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icons/mute-border-light",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "mic-off",
  transform: "translate(1.000000, 0.000000)",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,1 L22,23",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,9 L8,12 C8.00106654,13.2125666 8.73198021,14.305263 9.85230595,14.7691479 C10.9726317,15.2330328 12.2620527,14.9768812 13.12,14.12 M14.0000015,9.34 L14,4 C14.001549,2.45874069 12.8349546,1.16706808 11.3014976,1.01217343 C9.76804065,0.85727879 8.36670305,1.88956434 8.06,3.4",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,16.95 C14.0029591,18.9883773 10.9684939,19.610456 8.33049621,18.5222819 C5.69249854,17.4341079 3.97912302,14.8535449 4,12 L4,10 M18,10 L18,12 C17.9996407,12.41244 17.9628309,12.8240412 17.89,13.23",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,19 L11,23",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,23 L15,23",
  id: "Shape"
})));

var SvgMuteBorderLight = function SvgMuteBorderLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMuteBorderLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mute-border-light.57c7e9cc.svg";
export { ForwardRef as ReactComponent };